<template>
  <nav id="breadcrumbs" class="mb-3">
    <ul>
      <li v-if="showHome">
        <router-link :to="homeRoute">
          <i :class="homeIcon"></i>
        </router-link>
      </li>
      <li v-for="(item, index) in items" :key="index">
        <router-link v-if="item.route" :to="item.route">
          {{ item.name }}
        </router-link>
        <span v-else>{{ item.name }}</span>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    showHome: {
      type: Boolean,
      default: true
    },
    homeRoute: {
      type: Object,
      default: () => ({ name: 'company.dashboard' })
    },
    homeIcon: {
      type: String,
      default: 'uil-home-alt'
    }
  }
}
</script>

<style scoped>

</style>

